module.exports = __webpack_public_path__ + "assets/img/networkbehavior.8de7fc49.svg";